import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../../assets/springwater/movie.mp4';
const _hoisted_1 = {
  class: "springwaterList_s"
};
const _hoisted_2 = {
  class: "iconButton"
};
const _hoisted_3 = {
  key: 0,
  class: "videoBg"
};
const _hoisted_4 = {
  key: 1,
  class: "videoGif"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "searchBox searchBoxBlock"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "types"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  id: "cont3d"
};
const _hoisted_11 = {
  class: "clearfix cont3dlist"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  style: {
    "color": "#fff"
  }
};
const _hoisted_14 = {
  class: "item"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 0,
  class: "emptyText"
};
const _hoisted_17 = {
  class: "btnRight"
};
const _hoisted_18 = {
  class: "swiper-container nav",
  id: "nav",
  ref: "swiperNav"
};
const _hoisted_19 = {
  class: "swiper-wrapper"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "btnLeft"
};
const _hoisted_22 = {
  key: 0,
  class: "navText"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "icon-list"
  }, null, -1)), _createElementVNode("div", {
    class: "icon-apoints",
    onClick: _cache[0] || (_cache[0] = $event => $options.toList())
  })]), !$options.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[7] || (_cache[7] = [_createElementVNode("video", {
    src: _imports_0,
    autoplay: "autoplay",
    muted: "",
    loop: "loop"
  }, null, -1)]))) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.columns.length < 9 ? 'padding-left: 25px' : '')
  }, [_createElementVNode("img", {
    src: $data.config.logo
  }, null, 8, _hoisted_5)], 4), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    type: "",
    name: "",
    placeholder: "请输入搜索内容",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.searchKey = $event),
    onKeyup: _cache[2] || (_cache[2] = _withKeys($event => $options.toSearch(), ["enter"]))
  }, null, 544), [[_vModelText, $data.searchKey]]), _createElementVNode("div", {
    class: "search",
    id: "search",
    onClick: _cache[3] || (_cache[3] = $event => $options.toSearch())
  }, "搜索")]), _createElementVNode("ul", {
    class: _normalizeClass(`columns ${$data.columns.length > 8 ? 'columnsMore' : ''}`)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.columns, (item, index) => {
    return _withDirectives((_openBlock(), _createElementBlock("li", {
      class: _normalizeClass($data.columnIndex == index ? 'active' : ''),
      onClick: $event => $options.changeColumn(index, item)
    }, [_createElementVNode("div", null, _toDisplayString(item.columnName), 1)], 10, _hoisted_7)), [[_vShow, $data.columns.length > 2]]);
  }), 256))], 2), _createElementVNode("ul", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, n => {
    return _createElementVNode("li", {
      class: _normalizeClass($data.a_type == n ? 'active' : ''),
      onClick: $event => $options.changeTypes(n)
    }, _toDisplayString($data.types[n - 1]), 11, _hoisted_9);
  }), 64))]), _createElementVNode("div", {
    class: _normalizeClass(`cont3d cont3dBlock ${$options.isMobile ? 'h5' : ''}`)
  }, [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.datasAll, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "Item3d",
      onClick: $event => $options.toDetail(item)
    }, [_createElementVNode("span", _hoisted_13, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_15)])], 8, _hoisted_12);
  }), 256))])]), !$data.datasAll.length ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($data.datasLoading ? '加载中' : '暂无数据'), 1)) : _createCommentVNode("", true)], 2), $data.columns.length > 2 && !_ctx.$route.query.hideOthers && !_ctx.pageType && $options.isMobile ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "topNav",
    style: _normalizeStyle($data.showNavs ? 'width: 85px' : ''),
    onTouchstart: _cache[4] || (_cache[4] = (...args) => _ctx.touchstartNav && _ctx.touchstartNav(...args)),
    onClick: _cache[5] || (_cache[5] = $event => $options.isMobile ? $data.showNavs = true : '')
  }, [_withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [[_vShow, $data.showNavs]]), _withDirectives(_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.columns, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide navItem",
      onClick: $event => $options.toColumn(item.columnName, index)
    }, [_cache[8] || (_cache[8] = _createElementVNode("i", null, null, -1)), _createElementVNode("span", null, _toDisplayString(item.columnName), 1)], 8, _hoisted_20);
  }), 256))])], 512), [[_vShow, $data.showNavs]]), _withDirectives(_createElementVNode("div", _hoisted_21, null, 512), [[_vShow, $data.showNavs]]), !$data.showNavs ? (_openBlock(), _createElementBlock("div", _hoisted_22, "分类")) : _createCommentVNode("", true)], 36)) : _createCommentVNode("", true)]);
}